export default __webpack_public_path__ + "static/media/Intersect.7103d19a.svg";